export default "__VITE_ASSET__6GvdJug9__"